import React from 'react';
import i18next from 'i18next';
import { CreateAdStyled } from './styles';

const SiderCreateAd = () => (
  <CreateAdStyled>{i18next.t('advertisement.create')}</CreateAdStyled>
);

export default SiderCreateAd;
